import { Fragment } from "react";
import { styled } from "@mui/material/styles";
import AdSlot from "@pageContent/AdSlot";
import { AD_IDS } from "@pageContent/ArticleContent/ArticleContent";
import { ScreenSizes } from "@constants/consts";
import { RootNode } from "@typings/richText";
import { documentToReactComponents } from "@utils/pageContent/richTextToJSX";

const RichTextWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(4),
  marginTop: theme.spacing(4),
  [theme.breakpoints.up("md")]: {
    gap: theme.spacing(6),
  },
}));

const RichText: React.FC<{ richText: RootNode; screenSize?: ScreenSizes }> = ({ richText, screenSize }) => {
  return (
    <RichTextWrapper>
      {documentToReactComponents(richText).map((Item, index) => {
        return (
          <Fragment key={index}>
            {index === 1 && screenSize && <AdSlot id={AD_IDS[screenSize].articleContentBanner.id} />}
            {Item}
          </Fragment>
        );
      })}
    </RichTextWrapper>
  );
};

export default RichText;
